module.exports = Em.Route.extend({

    afterModel: function(payment) {
        var self = this
        return payment.promise.then(function() {
            var salesTaxReturn = payment.get('return')
            var orgUrl = self.modelFor('organization').get('url')
            var returnId = salesTaxReturn.get('id')
            self.transitionTo('/' + orgUrl + '/vat-declarations/' + returnId)
        })
    }
})
